import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DocStereoTypeDto, DocStereoTypesDto, GenericDocumentData } from 'shared';
import { ProjectDto } from 'shared';
import { SquirrelSessionRequest } from 'shared';
import { DataSharingService } from 'shared';
import { NotificationService } from 'shared';
import { OAuthServiceService } from 'shared';
import { ProjectService } from 'shared';
import { TranslateService } from 'shared';


import { GridApi, GridOptions, IDatasource, IGetRowsParams } from 'ag-grid-community';
//import 'ag-grid-community/dist/styles/ag-grid.css';
//import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { GenericFilter } from 'shared';
import { UserProjectsButtonRendererComponent } from './user-projects-button-renderer/user-projects-button-renderer.component';
import { Observable } from 'rxjs';
import { ProjectGroupRolePermissionService } from 'shared';
import { AgGridUserProjectsSettings } from './AgGridUserProjectsSettings';
import { TenantService } from 'shared';
import { EventsService } from 'shared';
import { SquirrelManagementService } from 'shared';
import { UserProjectsImageRendererComponent } from './user-projects-image-renderer/user-projects-image-renderer.component';
import { DatabaseMigrationService } from 'shared';
import { TenantDbVersion } from 'shared';
import { ConfirmDbwarningDialogComponent } from './confirm-dbwarning-dialog/confirm-dbwarning-dialog.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
    selector: 'project-list',
    templateUrl: './project-list.component.html',
    styleUrls: ['./project-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ProjectListComponent implements OnInit {

  _db:string = "";

  squirrelSessionRequest!: SquirrelSessionRequest;

  selectedRow: any;
  selectedRows!: number;

  project!: ProjectDto;

  docStereoTypesDto!: DocStereoTypesDto;
  docStereoTypeDto!: DocStereoTypeDto;
  docStereoTypeDtos!: DocStereoTypeDto[];

  docStType$!: Observable<DocStereoTypeDto[] | undefined>;

  genericDocumentData!: GenericDocumentData;

  rowData: ProjectDto[] = [];
  ds!: IDatasource;
  gridApi!: GridApi;
  gridOptions!: GridOptions;
  components: any;
  filter!: GenericFilter;
  sq_spinner: any = './assets/img/sq-spinner.gif';

  agGridUserProjSettings!: AgGridUserProjectsSettings
  public overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';

  //resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  checked = false;

  minDateTime = new Date("0001-01-01T00:00:00");

  tenantVersions!: TenantDbVersion;
  frontendUrl!: string;

  constructor(
    public dialog: MatDialog,    
    public translate: TranslateService,
    private oauthService: OAuthServiceService,
    private projectService: ProjectService,
    private dataSharingService: DataSharingService,
    private notificationService: NotificationService,
    private projectGroupRolePermissionsService: ProjectGroupRolePermissionService,
    private tenantService: TenantService,
    private eventsService:EventsService,
    private managementService: SquirrelManagementService,
    private databaseMigrationService: DatabaseMigrationService,
    
    ) { }

  ngOnInit(): void {

    //console.log("-----------> project-list")

    this.squirrelSessionRequest = new SquirrelSessionRequest();

    this.filter = new GenericFilter();
    this.agGridUserProjSettings = new AgGridUserProjectsSettings(this.translate);
    this.components = { buttonRenderer: UserProjectsButtonRendererComponent, imageRenderer: UserProjectsImageRendererComponent }
    this.gridOptions = this.agGridUserProjSettings.agGridUserProjectsSettings;

    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          let userRoles = (data as any).role as Array<string>;
          //console.log("-----------> project-list: user roles = ", userRoles)
          userRoles.forEach((dbrole: string) => {
            if (dbrole === 'admin') {
              this._db = dbrole;
              }
          });
        }
      }
    });

    this.tenantService.getTenant(this.tenantService.currentTenantId).subscribe({
      next: (tenantDto) => {
        this.frontendUrl = tenantDto.frontendUrl;
        console.log("------------> project-list: tenant frontendUrl = ", tenantDto.frontendUrl)
      },
      error: (error: any) => {
        //this.errorMessage = ErrorFormat.formatError(error);
        this.notificationService.error(`${this.translate.data["ERROR"]}`, "Error getting tenant frontendUrl")
        this.notificationService.info("", error.error.developerMessage.Message)
        console.log("------------> project-list: tenant db = ", error.error.developerMessage);
      }
    });

    //check if DB Version is up to date
    this.databaseMigrationService.getCurrentTenantDbVersion(this.tenantService.currentTenantName).subscribe({
      next: (version: TenantDbVersion) => {
        this.tenantVersions = version;
        console.log("------------> database-updates: tenant versions = ", version.dbVersion + " - " + version.requiredDbVersion);
        if (version.dbVersion != version.requiredDbVersion) {
          // this.notificationService.error(`${this.translate.data["ERROR"]}`, "Tenant DB version is not up to date");
          // this.notificationService.info("", "Please update the Tenant DB version");
          // const dialogRef = this.dialog.open(DeleteUserDialogComponent, {width: '500px',data:{userDto: userDto, params: this.params} }); 
          const dialogRef = this.dialog.open(ConfirmDbwarningDialogComponent, {width: '500px',data:null }); 
          dialogRef.afterClosed().subscribe((result:any) => {
            //if (result) {}
          });    
        }
        this.checked = true;
      },
      error: (error: any) => {
        //this.errorMessage = ErrorFormat.formatError(error);
        this.notificationService.error(`${this.translate.data["ERROR"]}`, "Error getting tenant versions")
        this.notificationService.info("", error.error.developerMessage.Message)
        console.log("------------> project-list: tenant db = ", error.error.developerMessage);
      }
    });       
  }
 
onGridReady(params: any) {
  //console.log("-----------> project-list onGridReady");

  this.gridApi = params.api;
  this.gridApi.sizeColumnsToFit();

  const datasource = {
    rowCount: 0,
    getRows: (dsParams: IGetRowsParams) => {

      this.gridApi.showLoadingOverlay();
      this.isLoadingResults = true;

      this.filter.className = 'Project';
      this.filter.startRow = dsParams.startRow;
      this.filter.endRow = dsParams.endRow;
      this.filter.sortItems = dsParams.sortModel;
      this.filter.clientFilters = dsParams.filterModel;

      const sort = dsParams.sortModel[0]?.sort ?? "asc";
      const sortField = dsParams.sortModel[0]?.colId ?? "display_Name";

      const db = this.tenantService.currentTenantName;

      this.tenantService.getUserProjects(this.filter, db).subscribe({
        next: (data) => {

          const filtered = data.filter(x =>
            new Date(x.archivedWhen).getTime() === this.minDateTime.getTime() ||
            x.archivedWhen == null
          );

          const sorted = filtered.sort((a, b) => {
            if (sort === "asc") {
              return a.display_Name > b.display_Name ? 1 : -1;
            } else {
              return a.display_Name < b.display_Name ? 1 : -1;
            }
          });

          const rows = sorted.slice(this.filter.startRow, this.filter.endRow);
          const lastRow = rows.length < this.filter.endRow ? rows.length : -1;

          dsParams.successCallback(rows, lastRow);

          this.isLoadingResults = false;
          this.gridApi.hideOverlay();

          if (rows.length === 0) {
            this.notificationService.info(
              `${this.translate.data["INFO"]}`,
              `${this.translate.data["NOPROJECTSRETRIEVED"]}`
            );
          }
        },

        error: (error: any) => {
          this.isLoadingResults = false;
          this.gridApi.hideOverlay();

          this.notificationService.error(
            `${this.translate.data["ERROR"]}`,
            `${this.translate.data["PROJECTRETRIVALERROR"]}`
          );

          console.log("-----------> project-list: error = ", error.error.developerMessage.Message);
          this.notificationService.info("", error.error.developerMessage.Message);
        }
      });
    }
  };

  this.gridApi.updateGridOptions({datasource: datasource});
}



  onRowClicked($event: any) {
    const rowData = [$event.node.data];
    //console.log("--------> project-list data = ", rowData[0])

    let db:string = this.tenantService.currentTenantName;
    console.log("--------> project-list frontendUrl = ", this.frontendUrl)
    //this.managementService.GetSq3ProjectAuthentification(db, rowData[0].id).subscribe({ 
    this.managementService.GetSq3ProjectAuthentificationId(db, rowData[0].id).subscribe({ 
      next: (sessionId) => {
        //console.log("-------> project-list sessionId: ", sessionId);
        //window.open(`https://project.squirrel-cde.de/?tenant=${db}&sessionId=${sessionId}`, '_blank');
        window.open(`${this.frontendUrl}/?tenant=${db}&sessionId=${sessionId}`, '_blank');
        // console.log("-------> project-list Project Url: ", `${projAuth.frontendurl}/Modell/?frontendkey=${projAuth.frontendkey}`);
        // window.open(`${projAuth.frontendurl}/Modell/?frontendkey=${projAuth.frontendkey}`, '_blank');
      },
      error: () => {
        this.notificationService.error(`${this.translate.data["ERROR"]}`, "management project authentication error")
      }
    })
  }

 onRowSelected($event: any) { }
}
